import React from 'react';
import "../../assets/css/Modal.css";

function AddTaskModal({setVisible}) {
      function closeModal(){
         setVisible(false);
      }
    return ( 
        <div className="modal-wrapper">
        <button onClick={closeModal} className="closeButton">
            X
        </button>

        <div className="Modal">
                <div className="top" >
                    <h2>Add Task</h2>
                </div>
                <div className="modal-body">
                   <div className='card' style={{width:800}}>
                    <div className='card-body'>
                    <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='row'>
                        <div className='row'>
                            <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Service Name</label>
                                    <select className='form-control'>
                                    <option>----</option>
                                   </select>
                                </div>
                            </div>
                            <div className='col md-6'>
                            <div className='form-group'>
                                    <label>Client Name</label>
                                    <select className='form-control'>
                                    <option>----</option>
                                   </select>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col md-6'>
                            <div className='form-group'>
                                    <label>Assign To</label>
                                    <select className='form-control'>
                                    <option>----</option>
                                   </select>
                                </div>
                            </div>
                            <div className='col md-6'>
                            <div className='form-group'>
                                    <label>Priority</label>
                                    <select className='form-control'>
                                    <option>High</option>
                                    <option>Low</option>

                                   </select>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col md-6'>
                            <div className='form-group'>
                                    <label>Delivary Date</label>
                                    <input size={10} type="date" className='form-control' />
                                </div>
                            </div>
                            <div className='col md-6'>
                            <div className='form-group'>
                                    <label>Time</label>
                                    <input size={10} type="time" className='form-control' />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col md-6'>
                            <div className='form-group'>
                                    <label>Status</label>
                                   <select className='form-control'>
                                    <option>Pending</option>
                                    <option>Ongoing</option>
                                    <option>Complete</option>

                                   </select>
                                </div>
                            </div>
                            <div className='col md-6'></div>
                        </div>
                        </div>
                    </div>
                  </div>
                    </div>
                   </div>
                    </div>
                    </div>
                     </div>
     );
}

export default AddTaskModal;